module.exports = '<svg width="27" height="32" viewBox="0 0 27 32"><path d="M9.162 0h8.359c.771 0 1.126.656 1.126 1.406V13.34h7.233c.771 0 1.033.651.584 1.267l-12.31 16.918c-.448.611-1.171.648-1.619.04L.219 14.583c-.448-.611-.187-1.243.584-1.243h7.172V1.406C7.972.656 8.391 0 9.162 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-arrow-1.js
// module id = 1108
// module chunks = 14